export const languages = {
  en: 'English',
  de: 'German',
  fr: 'French',
  it: 'Italian',
  nl: 'Dutch',
  pl: 'Polish',
  cs: 'Czech',
  sk: 'Slovak',
  da: 'Danish',
  fi: 'Finnish',
  no: 'Norwegian',
  sv: 'Swedish',
  es: 'Spanish',
  pt: 'Portuguese',
  hu: 'Hungarian',
  ro: 'Romanian',
  el: 'Greek',
};

export function getLanguageName(lang) {
  return languages[lang];
}

function getSelectOptions(languages) {
  return Object.keys(languages)
    .map((value) => ({ value, label: languages[value] }))
    .sort((a, b) => (a.label > b.label ? 1 : -1));
}

export const languageOptions = getSelectOptions(languages);

export const languageEnum = Object.keys(languages);



// WEBPACK FOOTER //
// ./src/js/widgets/Header/LanguageSelector/languages.js